import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full aspect-w-100 aspect-h-100 bg-gray-200 overflow-hidden aspect-h-63 md:aspect-h-71 md:aspect-w-100 xl:aspect-h-65 rounded-t-xl" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 0,
  class: "t-16m md:t-18m xl:t-20b"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

import {
  computed, onMounted, PropType, ref, toRefs,
} from 'vue';
import { getImgUrl } from '@/api';
import { handleImageError } from '@/util/funcs';
import { ReqHomesDocument } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
  home: {
    type: Object as PropType<ReqHomesDocument>,
    required: true,
  },
  selectedHomeId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props


const { home, selectedHomeId } = toRefs(props);
const homeImgUrl = ref('');
const isImageError = ref(false);

const selectedHome = computed(() => (home.value.id === selectedHomeId.value));

onMounted(async () => {
  if (home.value.elevationURL) {
    homeImgUrl.value = await getImgUrl({
      fileName: home.value.elevationURL,
    });
    isImageError.value = false;
  }
});

const error = (event: any) => {
  handleImageError(event);
  isImageError.value = true;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", {
    class: _normalizeClass(["shadow-modal rounded-xl h-full", [
      _unref(selectedHome) ? 'bg-wrh-blue-light' : 'bg-white',
    ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: homeImgUrl.value || '',
        alt: 'home.name' || 'avatar',
        width: "325",
        height: "224",
        class: _normalizeClass([[!isImageError.value ? 'object-center object-cover' : 'p-2'], "group-hover:opacity-85 transition-opacity duration-300 ease-in-out rounded-t-xl bg-wrh-gray-lighter"]),
        onError: error
      }, null, 42, _hoisted_2)
    ]),
    _createElementVNode("figcaption", {
      class: _normalizeClass(["p-4 pt-3 xl:p-6 xl:pt-4 t-12r xl:t-14r space-y-1", [
      _unref(selectedHome) ? 'text-white' : 'text-wrh-gray-dark',
    ]])
    }, [
      (_unref(home).planDescription)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_unref(home).planDescription), 1))
        : _createCommentVNode("", true),
      (_unref(home).community.name)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(home).community.name), 1))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, [
        (_unref(home).address)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_unref(home).address), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("p", null, [
        (_unref(home).city)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_unref(home).city), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_unref(home).state)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(", " + _toDisplayString(_unref(home).state), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_unref(home).zip)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(", " + _toDisplayString(_unref(home).zip), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (_unref(home).lotNumber)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Lot Number: " + _toDisplayString(_unref(home).lotNumber), 1))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})